import React from 'react';
import { Navigate, NavigateProps } from 'react-router-dom';

import { mergeWithFilteredQueryParams } from '@neo.tax/shared/utils';

export const NavigateTo = ({ to, ...rest }: NavigateProps): React.ReactElement => {
  // Object-form `to` (`{pathname, search, hash}`) is passed through unchanged:
  // callers using that shape own the full URL composition.
  const merged = typeof to === 'string' ? mergeWithFilteredQueryParams(to) : to;
  return <Navigate to={merged} {...rest} />;
};
